import type { LinkProps } from "@mui/material";
import { Link } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useIntercomContext } from "../contexts/IntercomContext";

interface Props extends Pick<LinkProps, "variant" | "underline" | "sx"> {
  articleId: string;
}

const HelpArticleLink = ({ articleId, variant, underline, sx, children }: PropsWithChildren<Props>) => {
  const { getArticleUrl, showArticle } = useIntercomContext();

  const handleClick = (event: React.MouseEvent) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      return;
    }
    event.preventDefault();
    showArticle(articleId);
  };

  return (
    <Link
      href={getArticleUrl(articleId)}
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
      underline={underline}
      sx={sx}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};

export default HelpArticleLink;
